export const formatSpecifications = (specs) =>
  specs
    .map((spec) => {
      const [id, data] = Object.entries(spec)[0];
      return {
        id: parseInt(id, 10),
        label: data.title.en,
      };
    })
    .sort((a, b) => a.id - b.id);

export const getProductDetailsSortedImagesByVariant = (images, variantSlug) => {
  if (!images || !Array.isArray(images)) return [];

  return [...images].sort((a, b) => {
    // Put matched variant first
    if (a.variant === variantSlug) return -1;
    if (b.variant === variantSlug) return 1;

    // Then sort by priority
    return a.priority - b.priority;
  });
};

export const getProductDetailsSortedImagesByPriority = (images) => {
  if (!images || !Array.isArray(images)) return [];

  return [...images].sort((a, b) => a.priority - b.priority);
};
